export class ExtendCostDocumentItemPair {
  costDocumentItemId!: number;
  documentItemId!: string;
  pairAmount!: number;
  isCurrencyDifferences!: boolean;
  amountToSetAsExchangeDifferences!: number;
}
